import {isDevMode, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {SharedModule} from "@shared/shared.module";

import {HelpComponent} from './routes/help/help.component';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    HelpComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ],
  exports: [
    HelpComponent
  ]
})
export class HelpModule {
  constructor() {
    if (isDevMode())
      console.info('HelpModule');
  }
}
